// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3UtQx","vLegacy":"SelectSecondary_vLegacy__2InSL","error":"SelectSecondary_error__OAC2p","disabled":"SelectSecondary_disabled__2Yzoc"};